// Página pública de baja de los correos informativos (/baja?t=…).
//
// El GET solo muestra el estado: dar de baja exige apretar el botón, porque los
// antivirus de correo abren los enlaces solos y darían de baja a la gente sin querer.
import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Alert, Button, Result, Spin } from 'antd';
import Comunicaciones, { mensajeError } from '../../../service/Comunicaciones';

export default function BajaComunicaciones() {
  const [params] = useSearchParams();
  const token = params.get('t');
  const [estado, setEstado] = useState(null);
  const [error, setError] = useState(null);
  const [ocupado, setOcupado] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('El enlace está incompleto.');
      return;
    }
    Comunicaciones.estadoBaja(token)
      .then(setEstado)
      .catch((e) => setError(mensajeError(e, 'El enlace no es válido o venció.')));
  }, [token]);

  const accion = async (fn) => {
    setOcupado(true);
    try {
      setEstado(await fn(token));
    } catch (e) {
      setError(mensajeError(e));
    } finally {
      setOcupado(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto px-4 py-16">
      {error && (
        <Result status="warning" title="No pudimos abrir tu suscripción" subTitle={error}
          extra={<Link to="/"><Button>Ir al inicio</Button></Link>} />
      )}
      {!error && !estado && <div className="flex justify-center"><Spin /></div>}
      {!error && estado && (
        <div className="bg-white rounded-2xl border border-gray-100 p-8 text-center shadow-sm">
          <h1 className="text-2xl font-extrabold text-gray-900 mb-2">
            {estado.informativos ? 'Correos informativos' : 'Listo, no te escribiremos más'}
          </h1>
          <p className="text-gray-600 mb-6">
            {estado.informativos
              ? <>¿Quieres dejar de recibir avisos y novedades en <strong>{estado.correoEnmascarado}</strong>?</>
              : <>Dimos de baja <strong>{estado.correoEnmascarado}</strong> de los correos informativos.</>}
          </p>
          {estado.informativos ? (
            <Button type="primary" danger size="large" loading={ocupado} onClick={() => accion(Comunicaciones.darDeBaja)}>
              Darme de baja
            </Button>
          ) : (
            <Button size="large" loading={ocupado} onClick={() => accion(Comunicaciones.deshacerBaja)}>
              Me equivoqué, volver a suscribirme
            </Button>
          )}
          <Alert className="mt-6 text-left" type="info" showIcon
            message="Las boletas y confirmaciones de tus inscripciones seguirán llegando: son el comprobante de lo que compras." />
        </div>
      )}
    </div>
  );
}
